import Api from "./Api";
export default {
    getDataCollectionsGrid(companyId) {
        return Api().get(`/data-collections/${companyId}`);
    },
    getDataCollectionsSimple(companyId) {
        return Api().get(`/data-collections-simple/${companyId}`);
    },
    addDataSource(payload) {
        return Api().post(`/data-collections`, payload);
    },
    editDataSource(payload) {
        return Api().post(`/data-collection/${payload.id}`, payload.data);
    },
    getDataSourceById(payload) {
        return Api().get(`/data-collection/${payload.companyId}/${payload.id}`);
    },
    deleteDataSource(payload) {
        return Api().delete(`/data-collection/${payload.companyId}/${payload.id}`);
    },
    deleteDataCollectionUrl(payload) {
        return Api().delete(`/data-collection-url/${payload.companyId}/${payload.id}`);
    },
    vensafeDataCollection(payload) {
        return Api().post(`/add-vensafe-data`, payload);
    },
};
